import { Grid } from '@mui/material';
import { plans } from 'account/plan/helper/Plans.data';
import { useState } from 'react';
import { PlanCard } from '../PlanCard/PlanCard';
import { SahinSwitch } from '../SahinSwitch/SahinSwitch';
import { useStyles } from './Landing.styles';

export const Plans = ({
  onSelect,
  switchColorful,
  sx,
  isYearlyPrice,
  ...rest
}: any) => {
  const { classes } = useStyles();
  const [isYearly, setYearly] = useState(false);

  const onSelectHandle = (selected: any, index: number) => {
    onSelect?.(selected, index, isYearly);
  };

  return (
    <Grid
      xs={12}
      justifyContent="center"
      className={classes.floor7}
      id="pricing"
      item
      container
      {...rest}
    >
      <Grid
        xs={12}
        justifyContent="center"
        sx={{ my: 10, mt: 1 }}
        item
        container
      >
        <SahinSwitch
          onChange={(value) => setYearly(value)}
          value={isYearly}
          label={isYearly ? 'YILLIK' : 'AYLIK'}
          informativeText={isYearly ? '%10 İNDİRİM' : undefined}
          sx={{ width: '250px', color: 'white' }}
          colorful={switchColorful}
        />
      </Grid>
      <Grid
        xs={12}
        lg={12}
        justifyContent="center"
        spacing={8}
        item
        container
        sx={(theme) => ({
          ...sx,
          [theme.breakpoints.down('md')]: {
            padding: '80px 0',
          },
        })}
        {...rest}
      >
        {plans.map((plan, index) => (
          <Grid key={index} xs={10} lg={12 / plans.length} item>
            <PlanCard
              xs={12}
              plan={plan}
              color={index}
              isYearly={isYearly}
              onSelect={(selected: any) => onSelectHandle(selected, index)}
              isYearlyPrice={isYearlyPrice}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
